import { createFileRoute } from '@tanstack/react-router'
import { AdminAuthGate } from '../components/auth/admin-auth-gate'
import { AdminCustomers } from '../components/pages/AdminCustomers'

export const Route = createFileRoute('/admin_/customers')({
  component: AdminCustomersComponent,
  head: () => ({
    title: 'Customers | AUTOGLOW Detailing Admin',
    meta: [
      { title: 'Customers | AUTOGLOW Detailing Admin' },
      { name: 'robots', content: 'noindex,nofollow' },
    ],
  }),
})

function AdminCustomersComponent() {
  return (
    <AdminAuthGate>
      <AdminCustomers />
    </AdminAuthGate>
  )
}
